import { atom, RecoilState} from 'recoil';
import { EAtomKeys, EErrorTypes } from 'interfaces';

export const ErrorState: RecoilState<any> = atom({
  key: EAtomKeys.Error,
  default: {
    [EErrorTypes.Global]: null
  }
});